import { useEffect } from 'react';

type CommonKey = 'Enter' | 'Escape' | (string & {});

export const useKeyPress = (targetKey: CommonKey, onKeyPress: () => void) => {
  useEffect(() => {
    const handleKeyDown = ({ key }: KeyboardEvent) => {
      if (key === targetKey) {
        onKeyPress();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [targetKey, onKeyPress]);
};
